import type { Ref } from 'vue';
import {
  ref,
} from 'vue';

import { watchImmediate } from '@vueuse/core';

export interface InputInnerValueComposable<T> {
  innerValue: Ref<T | undefined>;
  setValue(value: T): void;
}

export default function useInputInnerValue<T>(value: Ref<T>): InputInnerValueComposable<T> {
  const innerValue = ref<T>();

  function setValue(newValue: T): void {
    innerValue.value = newValue;
  }

  watchImmediate(value, setValue);

  return {
    innerValue,
    setValue,
  };
}
